import { hasOwnProperty } from "../../../infra3d";
import { Obj } from "../../internal";
export class AxisLoader extends Obj {
    constructor(scene) {
        super();
        this.scene = scene;
    }
    loadaxis(extent, srid, cbf) {
        return;
    }
    destroy() {
        return;
    }
    static orderByAxisId(geojson, axisid, tolerance) {
        const fc_obj = {};
        for (const feature of geojson.features) {
            if (hasOwnProperty(fc_obj, feature.properties[axisid])) {
                fc_obj[feature.properties[axisid]].push(feature);
            }
            else {
                fc_obj[feature.properties[axisid]] = [feature];
            }
        }
        // Check if the axis is contiguos -> if not make two features.
        for (const key in fc_obj) {
            for (let feature_key = 0; feature_key < fc_obj[key].length - 1; feature_key++) {
                const feature_coords = fc_obj[key][feature_key].geometry.coordinates[fc_obj[key][feature_key].geometry.coordinates.length - 1];
                const next_feature_coords = fc_obj[key][feature_key + 1].geometry.coordinates[0];
                if (!(Math.abs(feature_coords[0] - next_feature_coords[0]) <= tolerance &&
                    Math.abs(feature_coords[1] - next_feature_coords[1]) <= tolerance)) {
                    const features = fc_obj[key];
                    fc_obj[key] = features.slice(0, feature_key + 1);
                    fc_obj[key.toString() + "_1"] = features.slice(feature_key + 1);
                }
            }
        }
        const fc_axis_string = JSON.stringify({
            type: "FeatureCollection",
            features: [],
            crs: geojson["crs"],
        });
        const geojson_ret = [];
        for (const key in fc_obj) {
            const fc_axis = JSON.parse(fc_axis_string);
            fc_axis.features = fc_obj[key];
            geojson_ret.push({ value: fc_axis });
        }
        return geojson_ret;
    }
}
//# sourceMappingURL=axisloader.js.map